import TextContent from './TextContent';

export default TextContent;
